import axios from 'axios';

const RESSOURCE_NAME = 'entreprises';

export default {
    getUserEntreprise(idEntreprise){
        return axios.get(`${RESSOURCE_NAME}`+(idEntreprise?'/'+idEntreprise:''))
    },
    archiverEntreprise(idEntreprise){
        return axios.get(`${RESSOURCE_NAME}/active`+(idEntreprise?'/'+idEntreprise:''))
    },
    getEntreprises(size = process.env.VUE_APP_NB_DISPLAY, query = "", clients = true, prospects = true, visite = true, noVisite = true, projets = true, noProjet = true, page = 0, column = "raison_sociale", order = "ASC") {
        return axios.post(`${RESSOURCE_NAME}/search?page=${page}&size=${size}&orderBy=${column}&sortBy=${ order }`, { query: query, adresse: '', prospects: prospects, clients: clients, sansProjets: noProjet, avecProjets: projets, avecVisites: visite, sansVisites: noVisite })
    },
    createProspect(e){
        return axios.post(`${RESSOURCE_NAME}/create`,{prospect:e})
    },
    updateProspect(id,e){
        return axios.put(`${RESSOURCE_NAME}/update/`+id,{client:e})
    },
    criteresAchat(){
        return axios.get(`/criteresachat`)
    },
    achatsHydraulique(){
        return axios.get(`/achatshydraulique`)
    },
    getEntrepriseProjetsActive(idEntreprise,query="",column="date_projet",order="DESC",page=0){
        return axios.post(`${RESSOURCE_NAME}/`+idEntreprise+`/projets/active?page=`+page+`&size=`+process.env.VUE_APP_NB_DISPLAY+`&orderBy=`+column+`&sortBy=`+order+``,{query:query})
    },
    getEntrepriseProjetsClosed(idEntreprise,query="",column="date_projet",order="DESC",page=0){
        return axios.post(`${RESSOURCE_NAME}/`+idEntreprise+`/projets/?page=`+page+`&size=`+process.env.VUE_APP_NB_DISPLAY+`&orderBy=`+column+`&sortBy=`+order+``,{query:query})
    },
    getEntrepriseRetours(query = "", idEntreprise, page = 0, column = 'creation_date', order = 'DESC') {
        return axios.post(`${RESSOURCE_NAME}/${idEntreprise}/retours/active?page=` + page + `&size=` + process.env.VUE_APP_NB_DISPLAY + `&orderBy=` + column + `&sortBy=` + order + ``, { query: query })
    },
    getEntrepriseRetoursClosed(query = "", idEntreprise, page = 0, column = 'creation_date', order = 'DESC') {
        return axios.post(`${RESSOURCE_NAME}/${idEntreprise}/retours?page=` + page + `&size=` + process.env.VUE_APP_NB_DISPLAY + `&orderBy=` + column + `&sortBy=` + order + ``, { query: query })
    },
    getProspectToClient(idEntreprise,data){
        return axios.post(`${RESSOURCE_NAME}/status/${idEntreprise}`,{code_client_fta: data})
    },
    getEntrepriseRapports(query = "",idEntreprise, page = 0, column = 'date_rapport', order = 'DESC') {
        return axios.post(`${RESSOURCE_NAME}/${idEntreprise}/rapports?page=`+page+`&size=`+process.env.VUE_APP_NB_DISPLAY+`&orderBy=`+column+`&sortBy=`+order + ``, { query: query })
    },
    getEntrepriseDocumentsAndDirectory(path,id,mode,init,id_projet){
        return axios.post(`${RESSOURCE_NAME}/directories/${id}`,{directory:path,mode:mode,init,id_projet})
    },
    getAllEntrepriseRapports(idEntreprise){
        return axios.post(`${RESSOURCE_NAME}/${idEntreprise}/rapports?page=0&size=200&orderBy=date_rapport&sortBy=DESC`,{query:""})
    },
    getAllEntrepriseProjetsActive(idEntreprise){
        return axios.post(`${RESSOURCE_NAME}/${idEntreprise}/projets/active?page=0&size=${process.env.VUE_APP_NB_DISPLAY}&orderBy=date_projet&sortBy=DESC`,{query:""})
    },
    getAllEntrepriseProjetsClosed(idEntreprise){
        return axios.post(`${RESSOURCE_NAME}/${idEntreprise}/projets/?page=0&size=${process.env.VUE_APP_NB_DISPLAY}&orderBy=date_projet&sortBy=DESC`,{query:""})
    },
    mergeEntreprises(sourceId, targetId, fieldOverrides = {}, commerciauxChoice = null){
        return axios.post(`${RESSOURCE_NAME}/merge`, {
            source_id: sourceId,
            target_id: targetId,
            overrides: fieldOverrides,
            commerciaux_choice: commerciauxChoice,
        })
    },
}
